<template>
    <input
        :id="question.label"
        type="text"
        style="width: 100%"
        :placeholder="question.placeholder"
        @input="$emit('input', $event.target.value)"
    />
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    }
};
</script>
